module.exports = __webpack_public_path__ + "static/media/Urgent.29e7dd94.svg";